import { LoadLevel } from '@/shared/api/protocol-ts/model/dto_system_load_pb';

import { HighLoadLevel } from '../config';

export const isHighLoadLevel = (level: LoadLevel): level is HighLoadLevel =>
  level === LoadLevel.LoadLevel_Medium || level === LoadLevel.LoadLevel_High;
